import { isObject as e } from "@scalar/helpers/object/is-object";
import { isJsonMediaType as t } from "@scalar/helpers/http/is-json-media-type";
import { isXmlMediaType as n } from "@scalar/helpers/http/is-xml-media-type";
import { parseMimeType as r } from "@scalar/helpers/http/mime-type";
import { prettyPrintJson as i } from "@scalar/helpers/json/pretty-print-json";
//#region src/code-example/helpers/get-message-example-content.ts
var a = (a, o) => {
	if (a === void 0) return;
	let s = o === void 0 || t(o), c = Array.isArray(a) || e(a), l = !s && c, { subtype: u } = r(o), d = s || l ? "json" : n(o) ? "xml" : u === "yaml" || u === "x-yaml" || u.endsWith("+yaml") ? "yaml" : "plaintext";
	if (a === null || typeof a == "boolean") return {
		content: String(a),
		lang: d,
		structural: l
	};
	if (typeof a == "string") return {
		content: s ? i(a) : a,
		lang: d,
		structural: l
	};
	if (typeof a == "number" || Array.isArray(a) || e(a)) return {
		content: i(a),
		lang: d,
		structural: l
	};
};
//#endregion
export { a as getMessageExampleContent };

//# sourceMappingURL=get-message-example-content.js.map